import { get, getOr } from 'lodash/fp';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectProductForItem from '../../../../actions/selectProductForItem';
import getPLPUrl from '../../../../actions/getPLPUrl';

import EmptyProduct from './EmptyProduct';

const productLineButtonTexts = {
  1: 'Add Blinds to Window',
};

const mapStateToProps = ({ estimateBuilder }, { itemId }) => {
  const item = get(`entities.items.byId.${itemId}`, estimateBuilder);
  const designId = get('designId', item);
  const design = get(`entities.estimates.byId.${designId}`, estimateBuilder);

  const productLine = get('productLine', design);

  const buttonText = getOr('Shop All Products', productLine, productLineButtonTexts);
  const windowCategoryMappings = get('mandiAvailability.windowCategoryMappings', estimateBuilder);

  return {
    itemId,
    productLine,
    buttonText,
    windowCategoryMappings,
    designId,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  selectProductForItem,
  getPLPUrl,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EmptyProduct);
